import React, { useState } from 'react';
import CountUp from 'react-countup';


import About1 from '../../images/about/about-3.jpg';
import About2 from '../../images/about/about-4.jpg';
import Aut1 from '../../images/about/aut-1.jpg';
import Aut2 from '../../images/about/aut-2.jpg';
import Aut3 from '../../images/about/aut-3.jpg';

import Shape1 from '../../images/about/shape4.svg';
import Shape2 from '../../images/about/shape11.svg';
import Shape3 from '../../images/healthcare.svg';
import Shape4 from '../../images/about/shape10.svg';
import Shape5 from '../../images/about/call.svg';

const AboutS2 = (props) => {

    const [activeTab, setActiveTab] = useState(0);
    const handleTabClick = (index) => {
        setActiveTab(index);
    }

    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about-image">
                            <div className="image1">
                                <img src={About1} alt="" />
                            </div>
                            <div className="image2">
                                <img src={About2} alt="" />
                            </div>
                            <div className="shape-love">
                                <img src={Shape1} alt="" />
                            </div>
                            <div className="text">
                                <h2>Since</h2>
                                <h3><CountUp end={1999} enableScrollSpy /></h3>
                                <div className="shape">
                                    <img src={Shape2} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="right-content">
                            <h2>Building Your Community Mosque</h2>
                            <h3> Point Cook Islamic
                                <span> Community Ltd </span> (PCIC)</h3>
                            <p>Point Cook Islamic Community Ltd (PCIC) is a public company limited by guarantee, strictly not-for-profit, with a core focus on the advancement of Islam by building a Masjid in Point Cook. We are dedicated to serving the spiritual, educational, and social needs of our growing Muslim community, providing a welcoming space for worship, learning, and connection for families across Melbourne's west.</p>

                            <div className="about-tab">
                                <div className="tab" style={{display: 'flex', width: '100%'}}>
                                    <button className={activeTab === 0 ? 'tablinks active' : 'tablinks'} onClick={() => handleTabClick(0)} style={{flex: 1}}>Our Mission</button>
                                    <button className={activeTab === 1 ? 'tablinks active' : 'tablinks'} onClick={() => handleTabClick(1)} style={{flex: 1}}>Our Vision</button>
                                </div>
                                <div className={activeTab === 0 ? ' tabcontent active' : 'hidden'}>
                                    <div className="tab-wrap">
                                        <div className="right" style={{width: '100%'}}>
                                            <ul>
                                                <li><i className="flaticon-check"></i> Foster spiritual growth</li>
                                                <li><i className="flaticon-check"></i>Provide Islamic education for all ages
                                                </li>
                                                <li><i className="flaticon-check"></i>Unite and serve our community</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className={activeTab === 1 ? ' tabcontent active' : 'hidden'}>
                                    <div className="tab-wrap">
                                        <div className="right" style={{width: '100%'}}>
                                            <ul>
                                                <li><i className="flaticon-check"></i> A thriving Islamic centre for Point Cook
                                                </li>
                                                <li><i className="flaticon-check"></i>Comprehensive facilities for worship and learning
                                                </li>
                                                <li><i className="flaticon-check"></i>A beacon of Islamic values in Melbourne</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="author-wrap">
                                <ul className="author-img">
                                    <li><img src={Aut1} alt="" /></li>
                                    <li className="active"><img src={Aut2} alt="" /></li>
                                    <li><img src={Aut3} alt="" /></li>
                                </ul>
                                <div className="author-text">Growing Community <div className="shape"><img
                                    src={Shape4} alt="" /></div>
                                </div>
                                <div className="contact">
                                    <div className="icon">
                                        <img src={Shape5} alt="" />
                                    </div>
                                    <div className="text">
                                        <span>Contact:</span>
                                        <h4>info@pcic.org.au</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default AboutS2;



